import { render, staticRenderFns } from "./ModalFoto.vue?vue&type=template&id=7f469668&"
import script from "./ModalFoto.vue?vue&type=script&lang=js&"
export * from "./ModalFoto.vue?vue&type=script&lang=js&"
import style0 from "./ModalFoto.vue?vue&type=style&index=0&id=7f469668&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports